import {_} from 'lodash';
import {IObjectData, IRouteDefinitionParams, ISyncField} from '../../index';
import {AbstractWizard, template as tpl} from "./AbstractWizard";
import {global} from "../../appContext";
import {CREATING_MESSAGE} from "../../constants/Language";
import {getObjectType} from "../../util/misc";
import {ObjectTypeId} from "../../constants";
import {getHash} from "../../constants/RouteDefinitions";

export const template = tpl

export class viewModel extends AbstractWizard {

    protected readonly req_submit = global.getPromiseRequest("createobject")

    constructor(params: IRouteDefinitionParams) {
        super(params)
        this.init()
    }

    protected override init(): Promise<void> {
        return super.init()
            .then(() => {
                this.messageData(null)
                this.step(0)
            })
            .catch(this.onRequestError.bind(this))
    }

    protected resetSyncfields() {
        this.mutables().forEach(sfm => {
            if (sfm.mandatory) {
                sfm.value(null)
            } else {
                this.mutables.remove(sfm)
            }
        });
    }

    protected onSubmit() {
        const data = this.getSubmitData();
        this.messageData({message: CREATING_MESSAGE});
        this.req_submit.abort()
        return this.req_submit
            .request({jobject: JSON.stringify(data)})
            .then(this.onSubmitSuccess.bind(this))
            .then(() => this.messageData({message: `subject is created|s:((manual group))`}))
            .catch(this.onRequestError.bind(this))
    }

    protected getSubmitData(): Partial<IObjectData> {
        return {
            companyid: global.login.selectedOrganizationId() ?? '',
            id: 0,
            manual: true,
            orgnr: global.login.selectedOrganizationId() ?? '',
            syncfields: this.getSubmitSyncfields(),
            type: getObjectType(ObjectTypeId.Group),
        };
    }

    protected getSubmitSyncfields(): ISyncField[] {
        return this.mutables().map(sfm => {
            const sf: ISyncField = _.cloneDeep(sfm.syncfield)
            sf.value = this.getSubmitValue(sfm.name) ?? ''
            return sf
        })
    }


    protected override onSubmitSuccess(data: [IObjectData]) {
        super.onSubmitSuccess(data);
        this.groupLink = getHash('manualgroupdetails', {id: data[0].id}) ?? ''
    }

}
